module.exports = __webpack_public_path__ + "media/customizations/terramor/back-c59d5bcf6a8a1b10d6b9acd0381ca30b.jpg";